'use client'

import * as Sentry from '@sentry/nextjs'
import { useEffect, useRef } from 'react'
import { MEASUREMENT_PURPOSE, usePurposeConsent } from '@/features/gdpr/use-purpose-consent'
import { ignoreErrors } from '../../../sentry.config.helper'

// Sentry (error/analytics monitoring) only initialises — and only then can it send anything to
// /monitoring — once the user consents to Measurement (iubenda purpose 4), so nothing loads or is
// sent before consent. Independent of the maps/chat gates (those are purpose 3).
const isDevelopment =
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'development' ||
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'staging'

export const SentryConsentGate = () => {
    const consent = usePurposeConsent(MEASUREMENT_PURPOSE)
    const hasInited = useRef(false)

    useEffect(() => {
        if (consent !== true || hasInited.current) return

        hasInited.current = true

        Sentry.init({
            dsn: 'https://1faf882a367b55873bd495e75166832f@o4506858454712320.ingest.us.sentry.io/4506931180273664',
            release: process.env.VERCEL_GIT_COMMIT_SHA,
            tracesSampleRate: 0.001,
            debug: false,
            ignoreErrors,
            enabled: !isDevelopment,
        })
    }, [consent])

    return null
}
